import { NumberFieldUI } from '@axo/form/feature/form-input/NumberField/NumberFieldUI';
import { useTranslation } from '@axo/shared/i18n';
import { Grid } from '@axo/ui-core/components/layout/item';
import { formatSpacedNumber } from '../../../../../../utils/format';
import { gridColumns } from '../../../config/layouts/grid';
import type { IncomeFormGroupData } from '../../../FormData.no.types';
import { grossIncomeYearlyFieldOption } from './config';

export function IncomeFormGroup() {
  const { t } = useTranslation();

  return (
    <Grid columns={gridColumns}>
      <NumberFieldUI<IncomeFormGroupData>
        name="LoanApplication/GrossIncomeYearly"
        label={t('GrossIncomeYearly.label')}
        data-testid="gross-income-input"
        format={formatSpacedNumber}
        suffix={t('suffix.currency')}
        {...grossIncomeYearlyFieldOption}
      />
    </Grid>
  );
}
